import { type ReactNode } from 'react'

/**
 * Friendly "nothing here yet" panel for list views.
 *
 * Three slots:
 *   - `icon`  — a `lucide-react` glyph (default: nothing).
 *   - `title` — short headline ("Aucun planning aujourd'hui").
 *   - `body`  — one-sentence explanation.
 *   - `action`— optional CTA button (e.g. "Créer une mission").
 */
interface EmptyStateProps {
  icon?: ReactNode
  title: string
  body?: string
  action?: ReactNode
}

export function EmptyState({ icon, title, body, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center gap-3 px-6 py-12">
      {icon !== undefined ? (
        <div
          className="rounded-full bg-surface-muted p-4 text-text-muted"
          aria-hidden="true"
        >
          {icon}
        </div>
      ) : null}
      <h2 className="text-lg font-semibold text-text">{title}</h2>
      {body !== undefined ? (
        <p className="text-sm text-text-muted max-w-xs">{body}</p>
      ) : null}
      {action !== undefined ? <div className="mt-2">{action}</div> : null}
    </div>
  )
}
